// extracted by mini-css-extract-plugin
export default {"container":"s_container__cpFDJ","checkbox":"s_checkbox__xnhRq"};